<template>
	<div
		:class="{
			'calc-flex calc-flex-sm-col': variant === 'horizontal',
			'calc-flex-col': variant === 'vertical',
		}"
	>
		<ul
			:class="{
				'calc-flex flex-justify-center': variant === 'vertical',
				'calc-flex-col calc-flex-sm-row calc-flex-align-center':
					variant === 'horizontal',
			}"
			class="tabs calc-p-2 calc-pt-8 calc-sm-pt-2"
		>
			<li
				v-for="(tab, index) in tabList"
				:key="index"
				class="tab"
				:class="{
					'calc-btn calc-btn-white is-active':
						index + 1 === activeTab,
				}"
			>
				<label
					:for="`${uid}${index}`"
					class="cursor-pointer block text-center"
					v-text="tab"
				/>
				<input
					:id="`${uid}${index}`"
					v-model="activeTab"
					type="radio"
					:value="index + 1"
					class="hidden"
				/>
			</li>
			<span class="glider"></span>
		</ul>
		<template v-for="(tab, index) in tabList">
			<div
				v-if="index + 1 === activeTab"
				:key="index"
				class="calc-flex-grow-full"
			>
				<slot :name="`tabPanel-${index + 1}`" />
			</div>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		tabList: {
			type: Array,
			required: true,
		},
		variant: {
			type: String,
			required: false,
			default: () => "horizontal",
			validator: (value) => ["horizontal", "vertical"].includes(value),
		},
	},
	data() {
		return {
			activeTab: 1,
			uid: "calc-form-",
		};
	},
};
</script>
